import React, { useState } from "react";
import "./Subordinate_Data_card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";

function Subordinate_Data_card() {
  const [copiedIndex, setCopiedIndex] = useState(null);

  const cards = [
    {
      id: 1,
      uid: "15880367",
      level: 1,
      depositAmount: 0,
      betAmount: 32,
      commission: 0.19,
      time: "2026-03-12",
    },
    {
      id: 2,
      uid: "15880368",
      level: 2,
      depositAmount: 100,
      betAmount: 50,
      commission: 1.25,
      time: "2026-03-11",
    },
  ];

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);

    setTimeout(() => {
      setCopiedIndex(null);
    }, 2000);
  };

  return (
    <section className="Withdrawal_card_holder Subordinate_Data_card">
      {cards.map((card, index) => (
        <div className="Withdrawal_card" key={card.id}>
          <div className="card-top">
            UID:{card.uid}
            <div
              className="copy-wrapper"
              onClick={() => handleCopy(card.uid, index)}
            >
              <FontAwesomeIcon icon={faCopy} className="copy-icon" />
              {copiedIndex === index && (
                <div className="copy-tooltip">Copied!</div>
              )}
            </div>
          </div>

          <div className="card-body">
            <div className="row-item">
              <span className="label">Level</span>
              <span className="value">{card.level}</span>
            </div>

            <div className="row-item">
              <span className="label">Deposit Amount</span>
              <span className="value orange">{card.depositAmount}</span>
            </div>

            <div className="row-item">
              <span className="label">Bet Amount</span>
              <span className="value orange">{card.betAmount}</span>
            </div>

            <div className="row-item">
              <span className="label">Commission</span>
              <span className="value orange">{card.commission}</span>
            </div>

            <div className="row-item">
              <span className="label">Time</span>
              <span className="value ">{card.time}</span>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}

export default Subordinate_Data_card;
